import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "d-flex" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "el-upload__text" }, [
    /*#__PURE__*/ _createElementVNode("small", null, " Sign here ")
], -1 /* HOISTED */);
const _hoisted_3 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_input = _resolveComponent("el-input");
    const _component_upload_filled = _resolveComponent("upload-filled");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_el_space = _resolveComponent("el-space");
    const _component_el_upload = _resolveComponent("el-upload");
    const _component_Download = _resolveComponent("Download");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, null, {
        default: _withCtx(() => [
            _createVNode(_component_el_input, {
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event)),
                style: { "display": "none" }
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_upload, {
                    action: "#",
                    ref: "uploadRef",
                    class: _normalizeClass(`upload-file w-100 ${_ctx.disabled ? 'disabled' : ''}`),
                    accept: _ctx.accept,
                    "file-list": _ctx.filesInput,
                    "onUpdate:file-list": _cache[1] || (_cache[1] = ($event) => ((_ctx.filesInput) = $event)),
                    limit: 1,
                    "auto-upload": false,
                    "on-change": _ctx.onChange,
                    "on-remove": _ctx.onRemove,
                    disabled: _ctx.disabled,
                    drag: ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_space, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_upload_filled)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _hoisted_2
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["class", "accept", "file-list", "on-change", "on-remove", "disabled"]),
                (_ctx.defaultFileList.length)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _ctx.defaultFileList[0].url,
                        target: "_blank",
                        class: "ms-4 text-primary"
                    }, [
                        _createVNode(_component_el_icon, { class: "text-extra-large" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_Download)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ], 8 /* PROPS */, _hoisted_3))
                    : _createCommentVNode("v-if", true)
            ])
        ]),
        _: 1 /* STABLE */
    }));
}
